/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SchoolClass } from '../../models/school-class';

export interface CreateSchoolClass$Params {
  schoolId: string;
      body?: SchoolClass
}

export function createSchoolClass(http: HttpClient, rootUrl: string, params: CreateSchoolClass$Params, context?: HttpContext): Observable<StrictHttpResponse<SchoolClass>> {
  const rb = new RequestBuilder(rootUrl, createSchoolClass.PATH, 'post');
  if (params) {
    rb.path('schoolId', params.schoolId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SchoolClass>;
    })
  );
}

createSchoolClass.PATH = '/school/{schoolId}/classes';
